<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<div class="page-container p-lg">
	<div
		*ngIf="(loadStatus$ | async) === LoadStatus.LOADING"
		class="d-f fd-c ai-c w-100 mt-lg"
	>
		<mat-spinner diameter="30"></mat-spinner>
		<span class="mt-sm">Carregando informações...</span>
	</div>

	<ng-container
		*ngIf="
			(loadStatus$ | async) === LoadStatus.SUCCESS && (batchAction$ | async);
			let ba
		"
	>
		<div class="header-section d-f jc-sb ai-fs mb-lg">
			<div class="header-col">
				<span class="header-label">Operador</span>
				<span class="header-value">{{ ba.userName }}</span>
				<div
					class="status-chip mt-sm d-if ai-c"
					[class.success]="ba.status === uploadStatus.SUCCESS"
					[class.failure]="ba.status === uploadStatus.FAILURE"
					[class.in-progress]="ba.status === uploadStatus.IN_PROCESS"
				>
					<mat-icon
						*ngIf="ba.status === uploadStatus.SUCCESS"
						svgIcon="sanus-success"
					></mat-icon>
					<mat-icon
						*ngIf="ba.status === uploadStatus.FAILURE"
						svgIcon="sanus-alert-red"
					></mat-icon>
					<mat-spinner
						*ngIf="ba.status === uploadStatus.IN_PROCESS"
						diameter="16"
						class="mr-xs"
					></mat-spinner>
					<span>{{ statusLabel(ba.status) }}</span>
				</div>
			</div>
			<div class="header-col">
				<span class="header-label">Empresa</span>
				<span class="header-value">{{ ba.organizationName }}</span>
			</div>
			<div class="header-col">
				<span class="header-label">Data do upload</span>
				<span class="header-value">
					{{ ba.updatedAt | date: 'dd/MM/yyyy HH:mm' }}
				</span>
			</div>
		</div>

		<div
			class="actions-section d-f jc-fe mb-lg"
			*ngIf="ba.status === uploadStatus.SCHEDULED"
		>
			<button mat-stroked-button color="warn" (click)="cancelSchedule()">
				<mat-icon svgIcon="sanus-cancel" class="mr-xs"></mat-icon>
				Cancelar Agendamento
			</button>
		</div>

		<div class="messages-section mb-lg">
			<h2 class="section-title mb-md">Mensagens</h2>
			<div
				*ngIf="ba.status === uploadStatus.SUCCESS"
				class="success-message br-md p-md d-f ai-c"
			>
				<mat-icon svgIcon="sanus-success" class="mr-sm"></mat-icon>
				<span class="fs-sm">
					{{
						ba.description.message ||
							'Upload de documentos em massa realizado com sucesso.'
					}}
				</span>
			</div>
			<div
				*ngIf="ba.status === uploadStatus.FAILURE"
				class="failure-message br-md p-md d-f ai-c"
			>
				<mat-icon svgIcon="sanus-alert-red" class="mr-sm"></mat-icon>
				<span class="fs-sm">
					{{ ba.description.message }}
				</span>
			</div>
			<div
				*ngIf="ba.status === uploadStatus.IN_PROCESS"
				class="in-progress-message br-md p-md d-f ai-c"
			>
				<mat-spinner diameter="20" class="mr-sm"></mat-spinner>
				<span class="fs-sm">
					Upload de documentos em massa está sendo processado.
				</span>
			</div>

			<div
				*ngIf="
					ba.status === uploadStatus.SCHEDULED ||
					ba.status === uploadStatus.CANCELLED
				"
				class="scheduled-message br-md p-md d-f ai-c"
			>
				<mat-icon svgIcon="sanus-schedule" class="mr-sm"></mat-icon>
				<span class="fs-sm">
					{{ ba.description.message }}
				</span>
			</div>
		</div>

		<div
			class="messages-section mb-lg"
			*ngIf="ba.status === uploadStatus.FAILURE && tablesErros.length > 0"
		>
			<h2 class="section-title mb-md">Detalhes dos Erros</h2>
			<div
				*ngFor="let tableError of tablesErros"
				class="error-table-container mb-md"
			>
				<h3 class="fs-md fw-medium mb-sm">{{ tableError.name }}</h3>
				<div
					*ngFor="let errorDetail of tableError.errors"
					class="error-detail-item mb-sm"
				>
					<p class="fs-sm">
						<span class="fw-medium">Linha:</span>
						{{ errorDetail.row }}
					</p>
					<ul class="ml-md mt-xs">
						<li
							*ngFor="let detailedError of errorDetail.detailedErros"
							class="fs-sm error-text"
						>
							- {{ detailedError }}
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="documents-section mb-lg">
			<div class="d-f jc-sb ai-c mb-md">
				<h2 class="section-title">Documentos</h2>
				<button
					mat-stroked-button
					color="primary"
					(click)="downloadAllDocuments()"
					class="c-p"
					[disabled]="isDownloadingAll || !ba.files || ba.files.length === 0"
					*ngIf="ba.files && ba.files.length > 0"
				>
					<mat-spinner
						*ngIf="isDownloadingAll"
						diameter="20"
						class="mr-xs"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadingAll"
						svgIcon="sanus-download"
						class="mr-xs"
					></mat-icon>
					Baixar Todos
				</button>
			</div>
			<div class="document-list">
				<div
					class="document-item d-f jc-sb ai-c p-md"
					*ngFor="let doc of ba.files"
				>
					<div class="d-f ai-c">
						<mat-icon
							svgIcon="sanus-privacy-policy"
							class="mr-md file-icon"
						></mat-icon>
						<div class="d-f fd-c">
							<span class="doc-name">{{ doc.name }}</span>
							<span class="doc-meta fs-sm">{{ formatBytes(doc.size) }}</span>
							<span class="doc-meta fs-sm">
								Enviado por: {{ doc.userName }}
							</span>
							<span class="doc-meta fs-sm">
								Data: {{ doc.createdAt | date: 'dd/MM/yyyy HH:mm' }}
							</span>
						</div>
					</div>
					<div class="d-f ai-c">
						<button
							mat-icon-button
							(click)="downloadDocument(doc)"
							class="c-p download-button"
							[disabled]="downloadingStates[doc.id] || deletingStates[doc.id]"
							aria-label="Baixar documento"
						>
							<mat-spinner
								*ngIf="downloadingStates[doc.id]"
								diameter="20"
							></mat-spinner>
							<mat-icon
								*ngIf="!downloadingStates[doc.id]"
								svgIcon="sanus-download"
							></mat-icon>
						</button>
						<button
							mat-icon-button
							color="warn"
							(click)="deleteDocument(doc)"
							class="c-p ml-xs"
							[disabled]="downloadingStates[doc.id] || deletingStates[doc.id]"
							aria-label="Excluir documento"
						>
							<mat-spinner
								*ngIf="deletingStates[doc.id]"
								diameter="20"
							></mat-spinner>
							<mat-icon
								*ngIf="!deletingStates[doc.id]"
								svgIcon="sanus-trash"
							></mat-icon>
						</button>
					</div>
				</div>
				<div
					*ngIf="
						!ba.files ||
						(ba.files.length === 0 &&
							ba.status !== uploadStatus.SCHEDULED &&
							ba.status !== uploadStatus.CANCELLED)
					"
					class="p-md gray fs-sm"
				>
					Nenhum documento encontrado para esta ação.
				</div>
			</div>
		</div>
		<div *ngIf="ba.status === uploadStatus.SUCCESS">
			<div class="upload-section mb-lg">
				<h2 class="section-title mb-md">Enviar Novos Documentos</h2>
				<input
					type="file"
					#fileInput
					multiple
					(change)="onFileSelected($event)"
					style="display: none"
					accept="{{ acceptedExtensionsString }}"
				/>
				<div
					class="upload-area d-f fd-c ai-c jc-c p-lg br-dashed"
					[class.dragging-over]="isDraggingOver"
					(dragover)="onDragOver($event)"
					(dragleave)="onDragLeave($event)"
					(drop)="onDrop($event)"
					(click)="triggerFileInputClick()"
				>
					<mat-icon svgIcon="sanus-upload" class="upload-icon mb-md"></mat-icon>
					<span class="fs-md mb-sm">Arraste e solte arquivos aqui</span>
					<span class="upload-separator fs-sm mb-md">ou</span>
					<button
						mat-flat-button
						color="primary"
						class="c-p"
						(click)="$event.stopPropagation(); triggerFileInputClick()"
					>
						Selecionar Arquivos
					</button>
					<p class="mt-md fs-xs lh-xs ta-c gray">{{ extensionsMessage }}</p>
				</div>
			</div>

			<div
				class="selected-files-section mb-lg"
				*ngIf="selectedFiles.length > 0"
			>
				<h2 class="section-title mb-md">
					Arquivos Selecionados ({{ selectedFiles.length }})
				</h2>
				<div class="selected-files-list">
					<div
						class="selected-file-item d-f jc-sb ai-c p-md mb-sm"
						*ngFor="let file of selectedFiles; let i = index"
					>
						<div class="d-f ai-c file-info-container">
							<mat-icon
								svgIcon="sanus-privacy-policy"
								class="mr-md file-icon"
							></mat-icon>
							<div class="file-text-container">
								<span class="file-name">{{ file.name }}</span>
								<span class="file-size fs-sm">
									{{ formatBytes(file.size) }}
								</span>
							</div>
						</div>
						<button
							mat-icon-button
							(click)="removeSelectedFile(i)"
							class="c-p remove-button ml-sm"
							aria-label="Remover arquivo"
							[disabled]="isUploading"
						>
							<mat-icon svgIcon="sanus-trash"></mat-icon>
						</button>
					</div>
				</div>
				<div class="submit-container d-f jc-fe mt-md">
					<button
						mat-flat-button
						color="primary"
						(click)="uploadSelectedFiles()"
						[disabled]="selectedFiles.length === 0 || isUploading"
					>
						<mat-spinner
							*ngIf="isUploading"
							diameter="20"
							class="mr-xs"
						></mat-spinner>
						{{ isUploading ? 'Enviando...' : 'Enviar Documentos' }}
					</button>
				</div>
			</div>
		</div>
	</ng-container>

	<div
		*ngIf="
			(loadStatus$ | async) === LoadStatus.ERROR ||
			((loadStatus$ | async) === LoadStatus.SUCCESS &&
				(batchAction$ | async) === undefined)
		"
		class="d-f fd-c ai-c w-100 mt-lg gray"
	>
		<mat-icon svgIcon="sanus-alert-gray" class="large-icon mb-sm"></mat-icon>
		<span>Não foi possível carregar os detalhes da ação em massa.</span>
	</div>
</div>
